import React, { FC } from 'react';

interface IIconWrapperProps {
    height?: string;
    width?: string;
}

export const StarryUIIcon: FC<IIconWrapperProps> = ({ children, height = '24px', width = '24px' }) => {
    return (
        <svg role="presentation" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
            {children}
        </svg>
    );
};
